<template>
  <div style="height: inherit">

    <section class="chat-app-window">
      <!-- Start Chat Logo -->
      <div
        v-if="Object.keys(current_chat).length === 0"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle start-chat-text"
        >
         {{$t('creator.selectChat')}}
        </h4>
      </div>
      <div
        v-else
        class="active-chat"
      >
        <active-chat 
          :chat="chat_active" 
          :inner_loader="inner_loader"
          :proposals_user="proposals_user"
          :messages_format="messages_format"
          @update-chat="updateChat" 
          v-if="loaded_detail_chat"
        />
      </div>
    </section>

    <portal to="content-renderer-sidebar-left">
      <chat-left-side 
        :chats="all_chats" 
        @open-chat="openChat" 
        v-if="loaded" 
        @filter_chats="filterChats"
        :value_drop="value_drop"
        :key="update_chats"
        @load-more-chats="loadMoreChats"
        :is_loading="is_loading"
      />
    </portal>
  </div>
</template>

<script>
import chatLeftSide from '../chat/leftSideBar.vue'
import chat_service from '@/services/chat'
import proposals_services from '@/services/proposals';
import { getMotivationalPhrase } from '@/libs/utils/others'
import { getUserData } from '@/libs/utils/user';
import activeChat from './activeChat.vue';
//Domain
import { formatMessages } from '@/domain/chat/chat.domain';

export default {
  name: 'dashboardChat',
  components: {
    // BSpinner,
    chatLeftSide,
    activeChat,
  },
  data() {
    return {
      is_loading: false,
      has_more: true,
      page: 1,
      size_page: 10,
      getUserData,
      getMotivationalPhrase,
      chat_active: {},
      current_profile: {},
      all_chats: [],
      current_chat: {},
      proposal: {},
      loaded: false,
      loaded_detail_chat: false,
      value_drop: '',
      update_chats: false,
      interval_loading: null,
      inner_loader: false,
      proposals_user: [],
      messages_format: []
    }
  },
  created() {
    this.showLoader();

    const version = this.$route.query.type ?? 'new_chats';

    this.value_drop = version;
    if (this.value_drop === 'old_chats') {
      this.getChats({ has_sort: true }, true);
    } else {
      const data = { status: ["archived", "active", "leaved"] };
      this.getChatsV4(data);
    }


    this.$store.commit('appConfig/UPDATE_FOOTER_CONFIG', { type: 'hidden' });


    this.$root.$on('update_chat_notification', (chat_uuid) => {
      this.updateChat(chat_uuid);
    });
  },
  destroyed() {
    this.$store.commit('appConfig/UPDATE_FOOTER_CONFIG', { type: 'static' });
  },
  methods: {
    showLoader() {
      this.$vs.loading({
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
    },
    hideLoader() {
      clearInterval(this.interval_loading)
      this.inner_loader = false;
      this.$vs.loading.close()
    },
    getProposalsByUser(user_id) {
      proposals_services.getProposalsByUser(user_id).then((response) => {
        this.proposals_user = response.results;
      })
    },
    getChatsV4(data, reset_Page = false) {
      if (reset_Page) {
        this.page = 1;
        this.has_more = true;
        this.all_chats = [];
      }
      chat_service.getChatsV4(data,this.page, this.size_page).then((response) => {
        if (reset_Page) {
          this.all_chats = this.formatChats(response.results);
        } else {
          this.all_chats = [...this.all_chats, ...this.formatChats(response.results)];
        }

        this.loaded = true;
        this.hideLoader();
        this.update_chats = !this.update_chats;

        if (this.all_chats.length >= response.count) {
          this.has_more = false;
        }
      });
    },
    getChats(data, reset_Page = false) {
      if (reset_Page) {
        this.page = 1;
        this.has_more = true;
        this.all_chats = [];
      }

      chat_service.getChats(data, this.page, this.size_page).then((response) => {
        if (reset_Page) {
          this.all_chats = this.formatChats(response.results);
        } else {
          this.all_chats = [...this.all_chats, ...this.formatChats(response.results)];
        }

        this.loaded = true;
        this.hideLoader();
        this.update_chats = !this.update_chats;

        // Verifica si ya no hay más datos disponibles
        if (this.all_chats.length >= response.count) {
          this.has_more = false;
        }
      });
    },


    loadMoreChats() {
      // Si ya no hay más chats o estamos cargando, no hagas nada
      if (!this.has_more || this.is_loading) return;

      this.page++;
      this.is_loading = true;

      const service = this.value_drop === 'old_chats' ? chat_service.getChats({ has_sort: true }, this.page, this.size_page) : chat_service.getChatsV4({ status: ["archived", "active", "leaved"] }, this.page, this.size_page);

      service.then((response) => {

        const results = response.results || response.data?.results || [];

        this.all_chats = [
          ...this.all_chats,
          ...this.formatChats(results)
        ];

        this.update_chats = !this.update_chats;

        if (this.all_chats.length >= response.count) {
          this.has_more = false;
        }

        this.is_loading = false;

      }).catch(() => {
        this.is_loading = false;
      });
    },
    updateChat(chat_uuid) {
      this.showLoader();
      this.loaded_detail_chat = false;

      const detail_service = this.value_drop === 'old_chats' ? chat_service.getDetailChat(chat_uuid) : chat_service.getDetailChatV4(chat_uuid);

      detail_service.then(response => {
        this.chat_active = response;
        this.messages_format = formatMessages(this.chat_active);
        this.getProposalsByUser(response.creator.id);
        this.loaded_detail_chat = true;

        this.hideLoader();
      });

      const mark_service = this.value_drop === 'old_chats' ? chat_service.markAsReaded(chat_uuid) : chat_service.markAsReadedV4(chat_uuid);

      mark_service.then(() => {});
    },
    openChat(chat_id) {

      if (!chat_id) return;

      this.$router.push({
        name: 'chat-proposal',
        params: { chat_uuid: chat_id },
        query: this.value_drop === 'old_chats' ? { type: 'old_chats' } : {}
      }).catch(() => {});
      this.inner_loader = true;

      const detail_service = this.value_drop === 'old_chats' ? chat_service.getDetailChat(chat_id) : chat_service.getDetailChatV4(chat_id);

      detail_service
        .then(response => {
          this.loaded_detail_chat = true;

          if (response.status >= 400) {
            this.$router.push({ name: 'dashboard-analytics' });
            return;
          }

          this.chat_active = response;
          this.messages_format = formatMessages(this.chat_active);
          this.hideLoader();
          this.getProposalsByUser(response.creator.id);
        })
        .catch(error => {
          console.error('Error loading chat detail:', error);
        });

      const mark_service = this.value_drop === 'old_chats' ? chat_service.markAsReaded(chat_id) : chat_service.markAsReadedV4(chat_id);

      mark_service.then(() => {});

      this.current_chat = this.all_chats.find(chat => chat.id === chat_id) === undefined ? {} : this.all_chats.find(chat => chat.id === chat_id);

      if (Object.keys(this.current_chat).length > 0) this.current_chat.unseenMsgs = 0;
    },
    filterChats(by_value) {
      
      
      this.$router.push({
        name: 'chat-proposal',
        query: by_value === 'old_chats' ? { type: 'old_chats' } : {}
      });
     
      this.showLoader();

      if (by_value === 'old_chats') {
        const data = { has_sort: true };
        this.getChats(data, true);
      } else {
        const data = { status: ["archived", "active", "leaved"] };
        this.getChatsV4(data, true);
      }

      this.current_chat = {};
      this.value_drop = by_value;
      this.$route.params.chat_uuid = undefined;
    },
    formatChats(chats) {
      const user = getUserData()
      const results = []
      chats.forEach(chat => {
        const obj = {
          id: chat.uuid,
          user: chat.creator.id === user.id ? chat.brand : chat.creator,
          lastMessage: chat.last_message,
          unseenMsgs: chat.unread_messages,
          ...chat
        }
        results.push(obj);
      });
      return results
    },
  },
} 
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
<style>
.sidebar-chats-responsive .b-sidebar{
  width: 280px !important;
}
@media(max-width: 900px) {
  .chat-application .content-right {
    width: auto !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
  }
  .content-area-wrapper {
    overflow-x: hidden !important;
  }
}
@media(max-width: 600px) {
  .content-area-wrapper {
    overflow-x: hidden !important;
  }
}
</style>
